import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptBill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"receipt-bill, purchase, invoice"} maskId="square-filled-radius-0-stroke-1-IconReceiptBill"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22.7071L17 19.7071L14.5 22.2071L12 19.7071L9.5 22.2071L7 19.7071L4 22.7071V2ZM8 7H16V8H8V7ZM8 11H12V12H8V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconReceiptBill;
